import { ELanguage } from '@microfrontends/react-components'
import dateFormat from 'dateformat'
import { IJobInfo } from '../components/JobItem/type'

const ALGOLIA_POSTED_LATEST_INDEX = process.env.ALGOLIA_POSTED_LATEST_INDEX || 'vnw_job_new_staging_latest'
const ALGOLIA_POSTED_OLDEST_INDEX = process.env.ALGOLIA_POSTED_OLDEST_INDEX || 'vnw_job_new_staging_oldest'
const ALGOLIA_DEFAULT_INDEX = process.env.ALGOLIA_DEFAULT_INDEX || 'vnw_job_new_staging'

export const sortByPostedDate: (string | undefined)[] = [ALGOLIA_POSTED_LATEST_INDEX, ALGOLIA_POSTED_OLDEST_INDEX]

interface IDate {
    postedDate: string
    expiredDate: string
    remainingDay: number
}
export const convertISOToMillisecond = (dateTime: string): number => {
    return Date.parse(dateTime) / 1000
}

export const formatUpdatedDate = (item: IJobInfo, langCode: ELanguage, t: (text: string) => string): IDate => {
    // Posted date + Expired date

    let expiryDiffDays: number = 1
    let postedDate: null | string = null
    let remainingDay: number = 1

    try {
        const publishedDate = convertISOToMillisecond(item.approvedOn)
        const onlineDate = convertISOToMillisecond(item.onlineOn)
        const priorityOrder = convertISOToMillisecond(item.priorityOrder)
        const expiredDate = convertISOToMillisecond(item.expiredOn)

        let updatedDateTS = onlineDate
        if (sortByPostedDate.includes(ALGOLIA_DEFAULT_INDEX)) {
            updatedDateTS = publishedDate
        } else {
            if (priorityOrder > 0) {
                updatedDateTS = priorityOrder
            }
        }

        const now = new Date()
        const today: any = new Date(dateFormat(new Date().getTime(), 'mm/dd/yyyy'))

        let updatedDate: any = new Date(updatedDateTS * 1000)

        updatedDate = new Date(dateFormat(updatedDate, 'mm/dd/yyyy'))
        // parsed to dd/mm/yyyy
        const parseDate = dateFormat(updatedDate, 'mm/dd/yyyy').split('/')
        const parseDateInString = [parseDate[1], parseDate[0], parseDate[2]].join('/')

        postedDate =
            dateFormat(updatedDate, 'mm/dd/yyyy') === dateFormat(now, 'mm/dd/yyyy')
                ? langCode === ELanguage.EN
                    ? 'Today'
                    : 'Hôm nay'
                : parseDateInString

        const expired: any = new Date(dateFormat(new Date(expiredDate * 1000), 'mm/dd/yyyy'))
        const diffTimeExpiry: any = Math.abs(expired - today)
        expiryDiffDays = Math.ceil(diffTimeExpiry / (1000 * 60 * 60 * 24))
        if (remainingDay < 1) remainingDay = 1
    } catch (e) {
        console.warn(`There is some issue with this job: `, item)
        console.warn('[ERROR caught]: ', e)
    }

    if (postedDate === null) postedDate = ''

    return {
        postedDate: postedDate,
        expiredDate: `${
            expiryDiffDays === 0
                ? t('Expires on today')
                : `${t('Expires: ')} ${t('in')} ${expiryDiffDays} ${t('day')}${expiryDiffDays > 1 ? t('s') : ''}`
        }`,
        remainingDay: expiryDiffDays
    }
}
